import { connect } from 'react-redux';
import CASH from './CASH';

import { setIncludeCash } from '../../common/cash/actions';

import { setCashIsVisible } from './actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.cashUI.isVisible,
    includeCash: state.cash.includeCash,
    setIncludeCash,
    setCashIsVisible,
});

const combinedActions = {
    setIncludeCash,
    setCashIsVisible,
};

export default connect(mapStateToProps, combinedActions)(CASH);



// WEBPACK FOOTER //
// ./src/containers/Inputs/CASH/index.js